import { generateMockMatterExpensePayload } from "@/lib/data/factories/matter-subitem-payload-factory";
import { useCreateMatterExpense } from "@/lib/data/react-query/matters/matter-expenses";
import { useCallback } from "react";
import { createMultiple } from "./mock-api-utils";

export const useCreateMockMatterExpense = () => {
  const createExpense = useCreateMatterExpense();

  const createMockMatterExpense = useCallback(
    async (
      matterId: string,
      count = 1,
      overrides: Record<string, unknown> = {},
    ) =>
      createMultiple(count, () =>
        createExpense.mutateAsync(
          generateMockMatterExpensePayload(matterId, overrides),
        ),
      ),
    [createExpense],
  );

  return {
    createMockMatterExpense,
    mutation: createExpense,
  };
};
